module.exports = __webpack_public_path__ + "img/qrcode.7f69d2bc.png";